var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-card",on:{"click":function($event){return _vm.handleCardClick()}}},[_c('v-icon',{attrs:{"color":"primary","large":""}},[_vm._v(_vm._s(_vm.stat.icon))]),_c('div',{staticClass:"contents"},[_c('h4',[_vm._v(_vm._s(_vm.stat.title))]),_c('h3',[_vm._v(_vm._s(_vm.stat.count))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }